import { style } from '@vanilla-extract/css';

import { documentContainer } from '../document/Document.css';

export const headingContainer = style({
  selectors: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].reduce(
    (acc, heading) => {
      acc[`${documentContainer} &:has(${heading})`] = {
        paddingTop: `var(--wt-${heading}-padding-top, 16px)`,
        paddingBottom: `var(--wt-${heading}-padding-bottom, 4px)`,
        paddingLeft: 'var(--wt-padding, 15px)',
        paddingRight: 'var(--wt-padding, 15px)',
      };

      return acc;
    },
    {} as Record<string, any>,
  ),
});

export const baseHeading = style({
  color: 'var(--post-section-text-color, var(--site-theme-text-on-background-color))',
  textAlign: 'var(--text-align, left)',
});

export const h1 = style({
  fontFamily: 'var(--wt-h1-font-family, inherit)',
  fontSize: 'var(--wt-h1-font-size, 28px)',
  lineHeight: 'var(--wt-h1-line-height, 42px)',
  fontWeight: 'var(--wt-h1-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h1-font-color, var(--site-theme-text-on-background-color)))',
});

export const h2 = style({
  fontFamily: 'var(--wt-h2-font-family, inherit)',
  fontSize: 'var(--wt-h2-font-size, 24px)',
  lineHeight: 'var(--wt-h2-line-height, 36px)',
  fontWeight: 'var(--wt-h2-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h2-font-color, var(--site-theme-text-on-background-color)))',
});

export const h3 = style({
  fontFamily: 'var(--wt-h3-font-family, inherit)',
  fontSize: 'var(--wt-h3-font-size, 20px)',
  lineHeight: 'var(--wt-h3-line-height, 30px)',
  fontWeight: 'var(--wt-h3-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h3-font-color, var(--site-theme-text-on-background-color)))',
});

export const h4 = style({
  fontFamily: 'var(--wt-h4-font-family, inherit)',
  fontSize: 'var(--wt-h4-font-size, 18px)',
  lineHeight: 'var(--wt-h4-line-height, 27px)',
  fontWeight: 'var(--wt-h4-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h4-font-color, var(--site-theme-text-on-background-color)))',
});

export const h5 = style({
  fontFamily: 'var(--wt-h5-font-family, inherit)',
  fontSize: 'var(--wt-h5-font-size, 16px)',
  lineHeight: 'var(--wt-h5-line-height, 24px)',
  fontWeight: 'var(--wt-h5-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h5-font-color, var(--site-theme-text-on-background-color)))',
});

export const h6 = style({
  fontFamily: 'var(--wt-h6-font-family, inherit)',
  fontSize: 'var(--wt-h6-font-size, 14px)',
  lineHeight: 'var(--wt-h6-line-height, 21px)',
  fontWeight: 'var(--wt-h6-font-weight, inherit)',
  color: 'var(--post-section-text-color, var(--wt-h6-font-color, var(--site-theme-text-on-background-color)))',
});

export const hTagStyleMap = {
  h1: h1,
  h2: h2,
  h3: h3,
  h4: h4,
  h5: h5,
  h6: h6,
} as Record<string, string>;
